import { DateTime } from 'luxon';
import Vue from 'vue';

export function DATEFILTER(value: string | Date) {
    if (value) {
        const datetime = typeof value === 'string' ? DateTime.fromISO(String(value)) : DateTime.fromJSDate(value);
        return datetime.toFormat('dd.MM.yyyy');
    }
}

export function DATETIMEFILTER(value: string | Date) {
    if (value) {
        const datetime = typeof value === 'string' ? DateTime.fromISO(String(value)) : DateTime.fromJSDate(value);
        return datetime.toFormat('dd.MM.yyyy, HH:mm');
    }
}

Vue.filter('date', DATEFILTER);

Vue.filter('datetime', DATETIMEFILTER);
